<div class="warp" [ngClass]="{'modular':modularId}" #trigger>
    <input class="date-input" placeholder="{{'questionBoard.display.chooseDate'| translate}}"
        value="{{answer.value| queDate:question?.definitions?.formatDate }}" disabled />
    <div class="date-warp" (click)="openPopupDate()">
        <svg-icon svgClass="svg-img date-open" src="/assets/images/display-question/date.svg"></svg-icon>
    </div>
</div>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="selectedDateIsOpened=false" [cdkConnectedOverlayOpen]="selectedDateIsOpened"
    cdkConnectedOverlayBackdropClass="backdrop-selection" [cdkConnectedOverlayPositions]="positonAreaForSelectedDate">
    <que-dual-calendar-range-picker *ngIf="question?.definitions?.formatDate != 'YYYY/MM'"
        [customDateFrom]="answer.value" (rangeChanged)="chooseDate($event)"
        [isSingalDate]="true"></que-dual-calendar-range-picker>

    <que-date-picker *ngIf="question?.definitions?.formatDate == 'YYYY/MM'" [customDate]="answer.value"
        (rangeChanged)="chooseDate($event)">
    </que-date-picker>
</ng-template>